module.exports = __webpack_public_path__ + "img/typing_result2.d2241152.png";